import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid, Typography, Chip, Divider, Box,
} from "@mui/material";
import {
  WhatsApp as WhatsAppIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  Store as StoreIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  MenuBook as MenuBookIcon,
  ErrorOutline as ErrorIcon,
  Tag as TagIcon,
} from "@mui/icons-material";

const STATUS_CONFIG = {
  aceptado:  { label: "Aceptado",  color: "#9e9e9e" },
  enviado:   { label: "Enviado",   color: "#2196f3" },
  entregado: { label: "Entregado", color: "#4caf50" },
  leido:     { label: "Leído",     color: "#2e7d32" },
  fallido:   { label: "Fallido",   color: "#f44336" },
};

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleString("es-PY", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
};

const InfoRow = ({ icon, label, value, valueColor }) => (
  <Grid item xs={12} sm={6}>
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
      <Box sx={{ color: "text.secondary", mt: "2px", flexShrink: 0 }}>{icon}</Box>
      <Box>
        <Typography variant="caption" color="text.secondary" display="block">
          {label}
        </Typography>
        <Typography variant="body2" fontWeight={500} sx={{ color: valueColor || "text.primary", wordBreak: "break-all" }}>
          {value || "—"}
        </Typography>
      </Box>
    </Box>
  </Grid>
);

const MensajeLogModal = ({ open, onClose, mensaje }) => {
  if (!mensaje) return null;

  const statusCfg = STATUS_CONFIG[mensaje.status] || STATUS_CONFIG.aceptado;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WhatsAppIcon sx={{ color: "#25d366" }} />
            <Typography fontWeight="bold">Detalle del mensaje</Typography>
          </Box>
          <Chip
            label={statusCfg.label}
            size="small"
            sx={{ color: statusCfg.color, bgcolor: `${statusCfg.color}1a`, fontWeight: 600 }}
          />
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2.5}>
          {/* Destinatario */}
          <InfoRow
            icon={<PersonIcon fontSize="small" />}
            label="Destinatario"
            value={mensaje.destinatario_nombre}
          />
          <InfoRow
            icon={<WhatsAppIcon fontSize="small" />}
            label="Teléfono"
            value={mensaje.destinatario_telefono}
          />
          <InfoRow
            icon={<BusinessIcon fontSize="small" />}
            label="Empresa (RUC)"
            value={mensaje.empresa_ruc}
          />
          <InfoRow
            icon={<StoreIcon fontSize="small" />}
            label="Sucursal"
            value={mensaje.sucursal_codigo}
          />
          <InfoRow
            icon={<MenuBookIcon fontSize="small" />}
            label="Plantilla"
            value={mensaje.template_nombre}
          />

          <Grid item xs={12}><Divider /></Grid>

          {/* Timestamps */}
          <InfoRow
            icon={<ScheduleIcon fontSize="small" />}
            label="Fecha de envío"
            value={formatDate(mensaje.fecha_envio)}
          />
          <InfoRow
            icon={<CheckCircleIcon fontSize="small" />}
            label="Entregado"
            value={formatDate(mensaje.fecha_entregado)}
            valueColor={mensaje.fecha_entregado ? "#4caf50" : undefined}
          />
          <InfoRow
            icon={<CheckCircleIcon fontSize="small" />}
            label="Leído"
            value={formatDate(mensaje.fecha_leido)}
            valueColor={mensaje.fecha_leido ? "#2e7d32" : undefined}
          />
          {mensaje.fecha_fallido && (
            <InfoRow
              icon={<ErrorIcon fontSize="small" />}
              label="Fallido"
              value={formatDate(mensaje.fecha_fallido)}
              valueColor="#f44336"
            />
          )}

          <Grid item xs={12}><Divider /></Grid>

          {/* Meta */}
          <InfoRow
            icon={<TagIcon fontSize="small" />}
            label="Meta Message ID (wamid)"
            value={mensaje.meta_message_id}
          />

          {/* Error (solo si tiene) */}
          {(mensaje.error_codigo || mensaje.error_mensaje) && (
            <>
              <InfoRow
                icon={<ErrorIcon fontSize="small" />}
                label="Código de error"
                value={mensaje.error_codigo}
                valueColor="#f44336"
              />
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                  <Box sx={{ color: "text.secondary", mt: "2px", flexShrink: 0 }}>
                    <ErrorIcon fontSize="small" />
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      Detalle del error
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#f44336",
                        bgcolor: "#fdecea",
                        borderRadius: 1,
                        px: 1.5,
                        py: 0.75,
                        mt: 0.5,
                        fontWeight: 500,
                      }}
                    >
                      {mensaje.error_mensaje}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined" size="small">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MensajeLogModal;
